import { Box } from '@chakra-ui/react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import SystemSettings from './SystemSettings';

function GlobalOptions(props) {
  const { path } = useRouteMatch();
  return (
    <>
      <Box>
        <Switch>
          <Route
            path={`${path}`}
            render={() => <SystemSettings dataUser={props.dataUser} />}
          />
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default GlobalOptions;
